import React from 'react';
import AppHeader from '../../components/Header/Header';
import AppLayout from '../../components/layout';
import BannerSection from '../../components/ui/BannerSection';
import JornadaCientificaMenu from '../../components/ui/AreaCientifica';
import SectionHeading from '../../components/SectionHeading';
import BreadcrumbNav from '../../components/ui/BreadcrumbNav';

const caminho = [
  { label: 'Home', href: '/', icon: 'bi bi-house-door' },
  { label: 'Área Científica' },
  { label: 'Investigação' },
];

function JornadaCientifica() {
    return (
        <>
        <header id='header'>
        <AppHeader />
        </header>
        <BannerSection
                title="Jornada Científica"
                subtitle="Bem-vindo à Jornada Científica do ISP-Atlântida"
                description={`Participe da jornada científica do ISP-Atlântida, um evento anual que promove a pesquisa e o desenvolvimento científico na instituição. Conheça os trabalhos de pesquisa realizados por alunos e professores, além de palestras e debates sobre temas relevantes para a comunidade acadêmica.`}
                backgroundImage={require('../../assets/JorBanner.jpg')}
                backgroundId="instituition-Banner"
            />
            <BreadcrumbNav items={caminho} />
            <main className="px-3 px-md-5 px-xl-5 px-xxl-5 py-2">
            <br />
            <div className="row flex-row-reverse">
                <div className="col-12 col-md-4 col-lg-3 col-xl-2 col-xxl-2 menu-color">
                    <JornadaCientificaMenu />
                </div>
                <div className="col-12 col-md-8 col-lg-9 col-xl-10 col-xxl-10">
                <br />
                <div className="details-magazine" id='detalhes'>
                    <p className="f-reg">
                          <SectionHeading title="O que é Jornada Científica?" />
                    <br />
                    A jornada científica é um evento acadêmico e/ou científico que reúne pesquisadores, estudantes, profissionais e outros interessados para a apresentação, discussão e divulgação de pesquisas, estudos e avanços em diversas áreas do conhecimento. Esse tipo de evento visa promover a troca de ideias, o desenvolvimento de novos conhecimentos e o fortalecimento da colaboração entre diferentes áreas de pesquisa. <br /><br />
                    As Jornadas Científicas do ISP- Atlântida realizadas anualmente consistem num espaço de partilha de conhecimento e troca de experiências científicas entre investigadores, docentes, discentes e outros profissionais do sector público e privado. Por outro lado, propõe-se, igualmente, motivar a comunidade estudantil para o desenvolvimento de habilidades relativas à investigação científica
                    <br /><br />
                    A jornada científica do ISP-Atlântida é um evento anual que visa promover a pesquisa e o desenvolvimento científico na instituição. Durante a jornada, são apresentados trabalhos de pesquisa realizados por alunos e professores, além de palestras e debates sobre temas relevantes para a comunidade acadêmica. O evento é uma oportunidade para os participantes compartilharem conhecimentos, trocarem experiências e fortalecerem a cultura científica na instituição.
                    <br /><br />
                    Deste modo, a 6ª Jornadas Científicas do ISPA decorreu entre <b> 14 - 18 de Abril de 2025</b> incluirão um conjunto de actividades científicas, tais como, mesas redondas e palestras, sendo um fórum privilegiado de incentivo ao espírito crítico-reflexivo, criativo e investigativo das pessoas envolvidas, enquadrados nos desafios dos 50 anos de caminhada de Angola à independência, olhando para as perspectivas sócio-económica.
                    </p>
                    <br />
                </div>
                <br /><br />
                </div>
            </div>
            <br />
            <br />
            <br />
            <br />
            <br />
            </main>
        <AppLayout />
        </>
       
    );
}

export default JornadaCientifica;